import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Paper,
} from "@mui/material";

const DisplayComparison = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [groups, setGroups] = useState([]);
  const [selected, setSelected] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/enterprise/comparison/groups`)
      .then((r) => r.json())
      .then((res) => setGroups(res.data));
  }, []);

  const load = async (id) => {
    const res = await fetch(`${API_URL}/enterprise/comparison/${id}`);
    const result = await res.json();
    setData(result.data.mappings);
    setSelected(id);
  };

  return (
    <div>
      {groups?.map((g) => (
        <Button key={g.id} onClick={() => load(g.id)}>
          {g.title}
        </Button>
      ))}

      {selected && (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Religion</TableCell>
                <TableCell>Node</TableCell>
                <TableCell>Summary</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((m, i) => (
                <TableRow key={i}>
                  <TableCell>{m.religionName}</TableCell>
                  <TableCell>{m.nodeTitle}</TableCell>
                  <TableCell>{m.summary}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </div>
  );
};

export default DisplayComparison;
